import { CommonModule, DatePipe } from '@angular/common';
import { Location } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Component, ElementRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '@environments/environment';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { ButtonModule } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';
import { DividerModule } from 'primeng/divider';
import { CardComponent } from '@shared/components/card/card.component';

@Component({
    selector: 'app-sales-report-layout',
    imports: [CommonModule, RouterModule, DatePipe, ButtonModule, ToolbarModule, CardComponent, DividerModule],
    templateUrl: './sales-report-layout.component.html',
    styleUrl: './sales-report-layout.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SalesReportLayoutComponent {
    today: Date = new Date();
    companyName = environment.companyName;
    logoPath = environment.logo;
    address = environment.address;
    email = environment.email;

    constructor(private location: Location) {}

    @ViewChild('pdfContent', { static: false }) pdfContent!: ElementRef;

    exportToPDF() {
        if (!this.pdfContent) {
            console.error('PDF content not found.');
            return;
        }

        const element = this.pdfContent.nativeElement;
        html2canvas(element, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a4');
            const imgWidth = 190;
            const pageHeight = 295;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;
            let position = 10;

            pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }

            const urlPath = this.location.path();
            const fileName = urlPath.split('/').pop() || 'report';

            pdf.save(`${fileName}.pdf`);
        });
    }

    back() {
        this.location.back();
    }
}
